export default __webpack_public_path__ + "static/dc-laptop-aec9046218d70cf551f6466effb614be.png";